import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectStreamService } from '../../current-project/project-stream.service';
import { TCFile } from '../../files/TCFile';
import { TCFileService, TCObjectType } from '../../files/TCFile.service';
import { ButtonType } from '../buttons/button';
import { BreadcrumbClickEvent, BreadcrumbItem } from '../custom-breadcrumb/custom-breadcrumb.component';

@Component({
    selector: 'file-explorer',
    templateUrl: './file-explorer.component.html'
})
export class FileExplorerComponent implements OnInit {
    @Input() maxHeight = '300px';
    @Input() summaryHeight = '200px';
    @Input() fileSummaryVisible = true;

    @Input() files: TCFile[] = [];

    @Output()
    selectedFiles = new EventEmitter<TCFile[]>(null);

    loading = true;
    projectId: string;
    workspaceFileId: string;
    workspaceFolderId: string;
    currentFolderDetails: TCFile;
    currentfolderItems: TCFile[] = [];
    TCObjectType = TCObjectType;

    ButtonType = ButtonType;
    breadcrumbItems: BreadcrumbItem[] = [];

    selectedFilesMap = new Map<string, TCFile>();

    constructor(private fileService: TCFileService, private projectStream: ProjectStreamService) {}

    ngOnInit(): void {
        this.loading = true;
        const project = this.projectStream.getCurrentProject();
        this.projectId = project?.id;
        this.breadcrumbItems = [{ id: project.rootId, display: project.name, folder: null }];
        this.loadInitialSelectedFiles();
        this.loadFolderDetails(project.rootId);
    }

    loadFolderDetails(folderId: string): void {
        this.loading = true;
        this.getFolderDetails(folderId, this.projectId).then(folderDetails => {
            this.currentFolderDetails = folderDetails;
            this.getFolderItemsList(this.currentFolderDetails.id, this.projectId)
                .then(folderItems => {
                    this.currentfolderItems = folderItems;
                })
                .finally(() => {
                    this.loading = false;
                });
        });
    }

    loadInitialSelectedFiles(): void {
        if (this.files && this.files.length) {
            this.files.forEach(file => {
                this.selectedFilesMap.set(file.id, file);
            });
        }
        this.selectedFiles.emit(this.getSelectedFiles());
    }

    getFolderDetails(folderId: string, projectId: string): Promise<TCFile> {
        return this.fileService.getFolderDetail(folderId, projectId);
    }

    getFolderItemsList(folderId: string, projectId: string): Promise<TCFile[]> {
        return this.fileService.getFolderItemsWithoutFilter(folderId, projectId);
    }

    getSelectedFiles(): TCFile[] {
        return Array.from(this.selectedFilesMap.values());
    }

    selectFile(file: TCFile, event?: any): void {
        if (event) {
            event.stopPropagation();
        }
        if (this.selectedFilesMap.has(file.id)) {
            this.deselectFile(file);
            return;
        }
        this.selectedFilesMap.set(file.id, file);
        this.selectedFiles.emit(this.getSelectedFiles());
    }

    deselectFile(file: TCFile): void {
        if (this.selectedFilesMap.has(file.id)) {
            this.selectedFilesMap.delete(file.id);
        }
        this.selectedFiles.emit(this.getSelectedFiles());
    }

    openFolder(folder: TCFile): void {
        this.breadcrumbItems.push({ id: folder.id, display: folder.name, folder: folder });
        this.loadFolderDetails(folder.id);
    }

    gobackToParent(): void {
        if (this.currentFolderDetails.parentId) {
            const parentId = this.currentFolderDetails.parentId;
            this.breadcrumbItems.pop();
            this.loadFolderDetails(parentId);
        }
    }

    navigateToFolder(crumb: BreadcrumbClickEvent): void {
        this.breadcrumbItems = [...crumb.currentCrumbs];
        this.loadFolderDetails(crumb.clickedItem.id);
    }
}
